import { Icon } from "@/react/components/shared/Icon";
import { useWidgetNavigate } from "@circle-react/components/HelpWidget/hooks/useWidgetNavigate";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const LinkCard = ({ title, url }: { title: string; url: string }) => {
  const navigate = useWidgetNavigate();

  const handleClick = () => {
    navigate(url);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="border-primary flex w-[368px] items-start gap-2 rounded-2xl border px-4 py-3"
    >
      <Icon type="copilot-chain-link" size={20} />
      <Typography.LabelSm weight="medium">{title}</Typography.LabelSm>
    </button>
  );
};
